import { Component, Inject, OnInit, ViewChild } from "@angular/core";
import { UserService } from "src/_services/user.service";
import { Router, ActivatedRoute } from "@angular/router";
import { Location } from "@angular/common";
import * as moment from "moment";
import {
  MatDialog,
  MatTableDataSource,
  MAT_DIALOG_DATA,
  PageEvent,
  MatDatepickerInputEvent,
  MatPaginator,
} from "@angular/material";
@Component({
  selector: "app-create-users",
  templateUrl: "./fund-statement.component.html",
  styleUrls: ["./fund-statement.component.scss"],
})
export class FundStatementComponent implements OnInit {
  displayedColumnsTable: string[] = [
    "Date",
    "OperatorId",
    "OperatorName",
    "Amount",
    "TransactionType",
    "TransactionID",
  ];
  partnerId:string="";
  operatorId:string="";
  tableData = new MatTableDataSource<any>();

  constructor(
    private userService: UserService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private location: Location
  ) {}
  
  ngOnInit() {
    this.operatorId = this.activatedRoute.snapshot.params.operatorId;
    this.partnerId = this.activatedRoute.snapshot.params.partnerId;
    this.viewFundStatement();
  }
  @ViewChild(MatPaginator) paginator: MatPaginator;

  // view-fund-statement
  viewFundStatement() {
    try {
      this.userService.viewFundStatementDetail(this.operatorId,this.partnerId).subscribe((res) => {
        if (res.status === "RS_OK") {          
        this.tableData = new MatTableDataSource<any>(res.operatorStatement);
        this.tableData.paginator = this.paginator;
        } else {
          if (res.errorDescription === "Invalid Token!") {
            sessionStorage.clear();
            this.router.navigateByUrl("/login");
          }
        }
      });
    } catch (err) {}
  }
  redirectPage() {
    this.location.back();
  }
  getDate = (date: number) => {
    return moment(date).format("DD MMM YYYY hh:mm A");
  };

}
